// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader_wrapper__JYeTW","loader":"Loader_loader__pvYRd","loadingImg":"Loader_loadingImg__5NTkm"};